import flatten from 'lodash/flatten'
import idx from 'idx'
import moment from 'moment'
import values from 'lodash/values'
import { createSelector } from 'reselect'

import { FAMILY_ALBUM_URL } from 'Global/constants'

const _events = state => state.familyAlbum.data
const _filters = state => state.familyAlbum.filters
const _limit = state => 20 // Hardcoded!
const _page = state => state.layout.familyAlbum.page

export const eventsDone = state => state.familyAlbum.done
export const eventsError = state => state.familyAlbum.error
export const eventsPending = state => state.familyAlbum.pending
export const isSearchVisible = state => state.familyAlbum.isSearchVisible
export const previewOpen = state => state.previewModalGeneric.visible

export const eventName = (state, props) => {
  const events = _events(state)
  const eventId = idx(props, _ => _.routeParams.eventId)
  const eventName = idx(events, _ => _[eventId].name)

  return eventName ? eventName : 'Family Album'
}

const _allPictures = (state, props) => {
  const allPictures = values(_events(state)).map(event => {
    return event.data || []
  })

  const flattenedPictures = flatten(allPictures)

  return flattenedPictures
}

const _filteredPictures = (state, props) => {
  const pictures = _allPictures(state, props)

  return pictures.filter(picture => {
    const eventId = idx(props, _ => _.routeParams.eventId)
    const filters = _filters(state)
    const { email } = filters

    if (eventId) {
      return picture.eventId === parseInt(eventId, 10)
    }

    if (email) {
      const { customers } = picture

      const isEmailPresent = customers.some(customer => customer.email.toLowerCase().includes(email))

      if (!isEmailPresent) {
        return false
      }
    }

    return true
  })
}

export const sortedPictures = createSelector(
  [_filteredPictures],
  pictures => pictures.slice().sort((a, b) => moment.utc(b.createdAt).diff(moment.utc(a.createdAt))),
)

export const slicedSortedPictures = createSelector(
  [sortedPictures, _limit, _page],
  (pictures, limit, page) => {
    return pictures.slice((page - 1) * limit, (page - 1) * limit + limit)
  },
)

export const pagination = createSelector(
  [sortedPictures, _limit, _page],
  (pictures, limit, page) => {
    return {
      page,
      pages: Math.ceil(pictures.length / limit),
      totalPictures: pictures.length,
    }
  },
)

export const previewPictures = createSelector(
  [slicedSortedPictures],
  pictures =>
    pictures.map(picture => ({
      meta: picture.customers.map(customer => customer.email).join(', '),
      src: `${FAMILY_ALBUM_URL}/${picture.edited}`,
    })),
)
